<template>
  <div>
    <QS-h4-title title="维保费项" />
    <!-- showType ===3 是详情 -->
    <div v-if="showType !== '3'">
      <div class="add_pay">
        <el-button  type="primary" @click="handleAdd">添加项目</el-button>
        <div class="msg">注：添加项目后，维保金额将根据各项目总额自动统计</div>
      </div>
      <el-form ref="elPayAllFrom" :model="tableDataFrom" :rules="rules">
        <el-table
          class="add_table"
          max-height="300"
          :data="tableDataFrom.tableData"
          style="width: 100%"
        >
          <el-table-column
            style="height: 300px"
            prop="payItem"
            align="center"
            label="支付项"
          >
            <template slot-scope="scope">
              <el-form-item
                :prop="`tableData.${scope.$index}.payItem`"
                :rules="rules.payItem"
              >
                <!-- 自定义切换开关 && 无选择项目 -->
                <div
                  v-if="!scope.row.customStatus && addPayList.length"
                  class="el_select_div"
                >
                  <el-select
                    size="small"
                    @change="handleSelect($event, scope.row.key)"
                    v-model="scope.row.payItem"
                    clearable
                    placeholder="请选择"
                  >
                    <el-option
                      v-for="item in addPayList"
                      :key="item.key"
                      :label="item.itemName"
                      :value="item.itemName"
                    >
                    </el-option>
                  </el-select>
                  <div
                    v-if="scope.row.isShowCustom"
                    @click="heddleCustom(scope.row.key)"
                    class="bbbb"
                  >
                    <i class="el-icon-circle-plus-outline"></i>自定义支付项目
                  </div>
                </div>
                <div class="el_input_div" v-else>
                  <el-input
                    maxlength="50"
                    placeholder="请输入自定义支付项"
                    v-model.trim="scope.row.payItem"
                    @input="(value) => payItemChange(value,scope.$index)"
                  ></el-input>
                  <!-- 无选择项目直接展示input 但是不展示切换按钮 -->
                  <i
                    v-if="addPayList.length"
                    @click="heddleCustomCut(scope.row.key)"
                    class="el-icon-error"
                  ></i>
                </div>
              </el-form-item>
            </template>
          </el-table-column>
          <el-table-column align="center" label="单价">
            <template slot-scope="scope">
              <el-form-item
                :prop="`tableData.${scope.$index}.unitPrice`"
                :rules="rules.unitPrice"
              >
                <el-input
                  placeholder="金额"
                  v-model="scope.row.unitPrice"
                  v-limit-money="true"
                  @input="(val) =>priceChange(val,scope.$index)"
                >
                  <template slot="append">元</template>
                </el-input>
              </el-form-item>
            </template>
          </el-table-column>
          <el-table-column align="center" label="数量">
            <template slot-scope="scope">
              <el-form-item
                :prop="`tableData.${scope.$index}.num`"
                :rules="rules.num"
              >
                <!-- <el-input-number
                  @input.native="heddleNumInput($event, scope.row.key)"
                  v-model="scope.row.num"
                  v-interage="true"
                  :min="1"
                ></el-input-number> -->
                <el-input
                  @input.native="heddleNumInput($event, scope.row.key)"
                  v-model.trim="scope.row.num"

                  v-interage="true"
                ></el-input>
              </el-form-item>
            </template>
          </el-table-column>
          <el-table-column align="center" label="工时费">
            <template slot-scope="scope">
              <el-form-item
                :prop="`tableData.${scope.$index}.workTimeFee`"
                :rules="rules.workTimeFee"
              >
              <el-input
                v-model.trim="scope.row.workTimeFee"
                v-limit-money="true"
                v-deleteEmoji="true"
              ></el-input>
              </el-form-item>
            </template>
          </el-table-column>

          <el-table-column align="center" prop="totalAmount" label="总额（元）">
            <template slot-scope="scope">
              {{ getTotalAmount(scope.row) }}
            </template>
          </el-table-column>
          <el-table-column align="center"  label="费用承担方" >
            <template slot-scope="scope">
              <div class="el_select_div">
                <el-form-item
                  :prop="`tableData.${scope.$index}.expenseBearingParty`"
                  :rules="rules.expenseBearingParty"
                >
                  <el-select placeholder="请选择" clearable v-model="scope.row.expenseBearingParty">
                    <el-option
                      v-for="item in expenseBearingPartyList"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"
                    >
                    </el-option>
                  </el-select>
                </el-form-item>
              </div>
            </template>
          </el-table-column>
          <el-table-column align="center" prop="set" label="操作">
            <template slot-scope="scope">
              <el-button
                type="text"
                size="small"
                @click.stop="handleDel(scope.row.key)"
                >删除</el-button
              >
            </template>
          </el-table-column>
        </el-table>
        <div>
          <div></div>
        </div>
      </el-form>
    </div>
    <div v-else>
      <el-table
        max-height="500"
        :data="tableDataFrom.tableData"
      >
        <el-table-column prop="payItem" align="center" label="支付项" />
        <el-table-column align="center" prop="unitPrice" label="单价（元）" >
          <template slot-scope="scope">
            <span
              v-thousand-separator="scope.row.unitPrice"
            ></span>
          </template>
        </el-table-column>
        <el-table-column align="center" prop="num" label="数量" />
        <el-table-column align="center" prop="workTimeFee" label="工时费">
            <template slot-scope="scope">
              <span v-thousand-separator="scope.row.workTimeFee"
            ></span>
            </template>
        </el-table-column>
        <el-table-column align="center" prop="totalAmount" label="总额（元）" >
          <template slot-scope="scope">
            <span
              v-thousand-separator="scope.row.totalAmount"
            ></span>
          </template>
        </el-table-column>
        <el-table-column align="center" label="费用承担方" >
          <template slot-scope="{row}">
            <span>
              {{row.expenseBearingPartysName }}
            </span>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <!-- <el-pagination
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page="currentPage"
      :page-sizes="[10, 20, 30, 40, 50]"
      :page-size="pagesize"
      :total="this.tableDataFrom.tableData.length"
      layout="total, sizes, prev, pager, next, jumper"
    >
    </el-pagination> -->

    <!-- <div class="count_all_Pay">
      <div class="splitline mt16 mb16" />
      <QS-h3-title>
        <template slot="title">维保金额</template>
      </QS-h3-title>
      <div class="splitline mt16 mb16" />
      <div class="count_all_Pay_tips">
        <div class="count_all_Pay_tips-title">应收金额：</div>
        <div class="count_all_Pay_tips-m">
          {{ numberWithCommas(countAllPay) }}
        </div>
      </div>
    </div> -->
  </div>
</template>

<script>
import { debounce } from '@/utils'
import selectOption from '@/store/dict/selectOptionDict'

export default {
  props: {
    addPayList: {
      type: Array,
      default: () => [],
    },
    dataList: {
      type: Array,
      default: () => [],
    },
    // 维保类型 1维修 2保养 4事故
    type: {
      type: [String, Number],
      default: () => '',
    },
    // 3-详情 非3-新增/编辑
    showType: {
      type: [String, Number],
      default: () => '1',
    },
    countAllPay: {
      type: [String, Number],
      default: () => '',
    },
  },
  computed: {
    // 费用承担方
    expenseBearingPartyList() {
      return this.dictParseList(selectOption.costBearingParty)
    },
  },
  watch: {
    dataList: {
      handler(val) {
        this.init()
      },
      deep: true,
    },
    tableDataFrom: {
      handler({ tableData }) {
        const status = tableData.length > 0
        // 没有添加项目的时候清0
        if (!status) {
          this.$emit('countAllPay', '')
        }
        // 有添加项目置灰 ‘维保总费用’ 输入项目
        // this.$emit('totalDisabled', tableData.length > 0)
        this.$emit('totalDisabled', true)
      },
      deep: true,
    },
  },
  data() {
    return {
      tableDataFrom: {
        tableData: [],
      },

      rules: {
        payItem: [
          { required: true, message: '支付项目不能为空', trigger: 'change' },
        ],
        unitPrice: [
          { required: true, message: '单价不能为空', trigger: 'blur' },
        ],
        num: [{ required: true, message: '数量不能为空', trigger: 'blur' }],
        workTimeFee: [{ required: true, message: '工时费不能为空', trigger: 'blur' }],
        expenseBearingParty: [{ required: true, message: '费用承担方不能为空', trigger: 'change' }],
      },
      pagesize: 10, // 默认分页每页数据量
      currentPage: 1, // 默认展示第一页数据
    }
  },
  mounted() {},
  methods: {
    init() {
      const { dataList, tableDataFrom } = this
      if (Array.isArray(dataList) && dataList.length) {
        // 回显示初始化数据处理
        tableDataFrom.tableData = dataList.map((item, index) => {
          return {
            ...item,
            key: index,
            customStatus: false, // 自定义切换
            isShowCustom: true, // 是否展示 ‘自定义按钮’ 解决错误提示与‘自定义按钮’重合
            expenseBearingPartysName: selectOption.costBearingParty[item.expenseBearingParty], // 费用承担方
          }
        })
      }
    },

    // 添加
    handleAdd: debounce(function () {
      if (!this.type) {
        this.$message.error('请先选择维保类型！')
        return
      }
      const { tableDataFrom } = this
      tableDataFrom.tableData.push({
        key: new Date().getTime(),
        payItem: '',
        unitPrice: '',
        num: '',
        totalAmount: '',
        customStatus: false, // 自定义切换
        isShowCustom: true, // 是否展示 ‘自定义按钮’ 解决错误提示与‘自定义按钮’重合
        workTimeFee: '', // 工时费
        expenseBearingParty: '', // 费用承担房
      })
    }, 300),
    // 校验
    handleValidate() {
      let rParam = null
      this.$refs.elPayAllFrom.validate((valid) => {
        if (valid) {
          rParam = this.tableDataFrom.tableData.map((item) => {
            const param = {
              payItem: item.payItem,
              unitPrice: item.unitPrice,
              num: item.num,
              totalAmount: item.totalAmount,
              workTimeFee: item.workTimeFee,
              expenseBearingParty: item.expenseBearingParty,
            }
            if (item.id) {
              param.id = item.id
            }
            return param
          })
        } else {
          // 提交时未填写支付项目 会提示 这时候隐藏‘自定义’文案 避免重合
          this.tableDataFrom.tableData.forEach((item) => {
            if (!item.payItem) {
              item.isShowCustom = false
            }
          })
        }
      })
      return rParam
    },
    // 删除
    handleDel(key) {
      this.tableDataFrom.tableData.splice(this.getIndex(key), 1)
    },
    heddleNumInput(e, key) {
      const _val = e.target.value
      this.tableDataFrom.tableData[this.getIndex(key)].num = _val
    },
    // 钱展示
    getTotalAmount(data) {
      // unitPrice：单价；num：数量；workTimeFee：工时费；key：索引
      const { unitPrice = 0, num = 0, workTimeFee = 0, key } = data || {}
      this.tableDataFrom.tableData[this.getIndex(key)].totalAmount = Number(unitPrice) * Number(num) + (Number(workTimeFee))
      // 计算费用总金额
      const resStove = this.tableDataFrom.tableData.reduce((pre, current) => {
        // totalAmount 所有费项总金额
        return pre + Number(current.totalAmount)
      }, 0)
      // 计算客户承担维保总金额（司机）
      const customerMaintenanceAmountTotal = this.tableDataFrom.tableData.reduce((pre, current) => {
        // expenseBearingParty：1 费用承担方为司机；totalAmount 所有费项总金额
        return pre + (current.expenseBearingParty === 1 ? Number(current.totalAmount) : 0)
      }, 0)
      // 传递给父组件（添加和编辑维保金额：费项总金额和客户承担维保总金额（司机））
      this.$emit('countAllPay', { resStove: resStove.toFixed(2), customerMaintenanceAmountTotal: customerMaintenanceAmountTotal.toFixed(2) })
      // 计算当前项费项总金额
      return this.numberWithCommas(Number(unitPrice) * Number(num) + (Number(workTimeFee)))
    },
    // 自定义
    heddleCustom(key) {
      this.tableDataFrom.tableData[this.getIndex(key)].customStatus = true
      this.tableDataFrom.tableData[this.getIndex(key)].payItem = ''
    },
    // 自定义切换
    heddleCustomCut(key) {
      this.tableDataFrom.tableData[this.getIndex(key)].customStatus = false
      this.tableDataFrom.tableData[this.getIndex(key)].payItem = ''
    },
    // 监听select 值变化
    handleSelect(val, key) {
      this.setCustom(val, key)
    },
    // 设置‘自定义按钮’展示与否
    setCustom(val, key) {
      if (val) {
        this.tableDataFrom.tableData[this.getIndex(key)].isShowCustom = true
      } else {
        this.tableDataFrom.tableData[this.getIndex(key)].isShowCustom = false
      }
    },
    // 获取数据中key所在位置
    getIndex(key) {
      const _idx = this.tableDataFrom.tableData.findIndex(
        (item) => item.key === key,
      )
      return _idx
    },
    // handleSizeChange: function (val) {
    //   this.pagesize = val
    // },
    // handleCurrentChange: function (currentPage) {
    //   this.currentPage = currentPage
    // },
    // 自定义支付项change
    payItemChange(value, index) {
      if (!value) {
        this.tableDataFrom.tableData[index].isShowCustom = false
      }
    },

    // 单价更改监听
    priceChange(value, index) {
      const result = value.replace(/[^0-9]{0,1}(\d*(?:\.\d{0,2})?).*$/g, '$1')
      this.$set(this.tableDataFrom.tableData[index], 'unitPrice', result)
    },
  },
}
</script>

<style lang="less" scoped>
// 添加项目
.add_pay {
  margin-bottom: 5px;
  display: flex;
  // align-items: flex-end;
  align-items: center;
  > .msg {
    margin-left: 5px;
    color: #8e8a8a;
    font-size: 12px;
  }
}

::v-deep input::-webkit-outer-spin-button,
::v-deep input::-webkit-inner-spin-button {
  -webkit-appearance: none !important;
}
::v-deep input[type='number'] {
  -moz-appearance: textfield;
}

.add_table ::v-deep .el-form-item {
  margin-top: 20px;
  margin-bottom: 20px;
}
.add_table ::v-deep td {
  padding: 0 !important;
}
.el_select_div {
  position: relative;
  ::v-deep .el-select {
    width: 100%;
  }
  .bbbb {
    position: absolute;
    font-size: 10px;
    line-height: 20px;
    color: #2e7eff;
    &:hover{
      cursor: pointer;
    }
  }
}
.el_input_div {
  display: flex;
  align-items: center;
  .el-icon-error {
    padding-left: 5px;
  }
}
.count_all_Pay {
  .count_all_Pay_tips {
    display: flex;
    font-weight: bold;
    padding-left: 10px;
    .count_all_Pay_tips-title {
    }
    .count_all_Pay_tips-m {
    }
  }
  padding-bottom: 30px;
}
</style>

